export default __webpack_public_path__ + "static/media/cardcredpal.bedd645a.svg";